import { GroupMetricType } from "components/DataGetter/FlightConfig/FlightConfigTypes/GroupMetricType";
import { ReportSummaryMetric } from "components/DataGetter/FlightConfig/FlightConfigTypes/ReportPageConfigType";
import { PageNameEnum } from "types/enums";

export function getFilterMetricByFlightConfig({
  pageName,
  processGroupName,
  processId,
}: {
  pageName: PageNameEnum;
  processGroupName?: string;
  processId?: string | null;
}): (metric: GroupMetricType | Partial<ReportSummaryMetric>) => boolean {
  return (metric: GroupMetricType | Partial<ReportSummaryMetric>) => {
    const keepForProcessIds =
      "hideForProcessIds" in metric &&
      metric.hideForProcessIds &&
      Array.isArray(metric.hideForProcessIds)
        ? // only show if we're on a single process page
          !processId ||
          // and if the current processId is in the list
          !metric.hideForProcessIds.includes(processId)
        : true;
    const onlyShowForProcessIds =
      "onlyShowForProcessIds" in metric &&
      metric.onlyShowForProcessIds &&
      Array.isArray(metric.onlyShowForProcessIds)
        ? // only show if we're on a single process page
          processId &&
          // and if the current processId is in the list
          metric.onlyShowForProcessIds.includes(processId)
        : true;
    const onlyShowForGroupIds =
      metric.onlyShowForGroupIds && Array.isArray(metric.onlyShowForGroupIds)
        ? // only show if we're on a single-group page with the specified summaryGroup
          processGroupName &&
          metric.onlyShowForGroupIds
            .map(s => s.toLowerCase())
            .includes(processGroupName.toLowerCase())
        : true;
    const keepForGroupIds =
      metric.hideForGroupIds && Array.isArray(metric.hideForGroupIds)
        ? // only show if we're on a single-group page with the specified summaryGroup
          !processGroupName ||
          !metric.hideForGroupIds
            .map(s => s.toLowerCase())
            .includes(processGroupName.toLowerCase())
        : true;
    const onlyShowOnPages =
      "onlyShowOnPages" in metric && metric.onlyShowOnPages
        ? // if current page is in the list, hide it
          metric.onlyShowOnPages.includes(pageName) ||
          // on operator page, metric.onlyShowOnPages "operatorPreferred" is also valid
          (pageName === PageNameEnum.operator &&
            metric.onlyShowOnPages.includes("operatorPreferred"))
        : true;
    const showOnPages =
      "hideOnPages" in metric && metric.hideOnPages
        ? // if current page is in the list, hide it
          !metric.hideOnPages.includes(pageName)
        : true;
    const keep =
      // given `hideOnPages` filter,
      showOnPages &&
      onlyShowOnPages &&
      onlyShowForGroupIds &&
      keepForGroupIds &&
      onlyShowForProcessIds &&
      keepForProcessIds;
    return Boolean(keep);
  };
}
